export default {
  VIDEOS: "/videos/:id/:slug",
  ACTIVITIES: "/activities/:id/:slug",
  TAGS: "/tags/:id/:slug",
  POST: "/company/posts/:slug",
};
